export class Task<T> {
	public readonly promise: Promise<T>;

	private completed = false;
	private resolve: null | ((value: T | PromiseLike<T>) => void);
	private reject: null | ((reason?: unknown) => void);

	public constructor() {
		this.resolve = null;
		this.reject = null;

		this.promise = new Promise<T>((resolve, reject) => ((this.resolve = resolve), (this.reject = reject)));
	}

	public resolveWith(value: T): void {
		this.complete();

		if (this.resolve === null) {
			return;
		}

		this.resolve(value);
	}

	public rejectWith(reason?: any): void {
		this.complete();

		if (this.reject === null) {
			return;
		}

		this.reject(reason);
	}

	private complete(): void {
		if (this.completed) {
			throw new Error('Task already completed');
		}

		this.completed = true;
	}
}
